var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('table',{staticClass:"table"},[_c('tbody',_vm._l((_vm.list),function(item){return _c('app-list-release-item',{attrs:{"item":item}})}),1)])])}
var staticRenderFns = []

export { render, staticRenderFns }